import { __decorate, __metadata } from "tslib";
import { injectable } from 'tsyringe';
import { placeholders } from '@gn-audio/core/common/helpers';
import { getTopMenuElement } from '@gn-audio/core/common/utilities';
import { BasketEventBus } from '../../services/basket-event-bus.service';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import './basket-icon.component.scss';
import template from './basket-icon.component.html';
var BasketIconComponent = /** @class */ (function () {
    function BasketIconComponent(eventBus) {
        var _this = this;
        this.eventBus = eventBus;
        this.reactOnStoreChanges = function (state) {
            if (!_this.basketIconElement) {
                return;
            }
            var totalCount = getBasketTotalCount(state);
            _this.basketIconElement.innerHTML = placeholders(template, { totalCount: totalCount });
        };
    }
    BasketIconComponent.prototype.register = function (state) {
        this.attachEvents();
        this.attachToTargetElement();
        this.reactOnStoreChanges(state);
    };
    BasketIconComponent.prototype.attachEvents = function () {
        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnStoreChanges);
    };
    BasketIconComponent.prototype.attachToTargetElement = function () {
        var targetElement = document.querySelector('.cart-item')
            || document.querySelector('.content-cart-item');
        if (!targetElement) {
            console.warn("Basket icon was not able to attach to cart-item target element");
            targetElement = document.querySelector('.top-menu__controls');
            if (!targetElement) {
                console.warn("Basket icon was not able to attach to top-menu__controls target element");
                return;
            }
            this.targetElement = targetElement.appendChild(this.getBasketWrapper());
        }
        else {
            var clonedTargetElement = targetElement.cloneNode(false);
            targetElement.parentNode.replaceChild(clonedTargetElement, targetElement);
            this.targetElement = clonedTargetElement;
        }
        this.createBasketIcon();
    };
    BasketIconComponent.prototype.createBasketIcon = function () {
        var _this = this;
        this.basketIconElement = document.createElement('div');
        this.basketIconElement.classList.add('basket');
        this.targetElement.appendChild(this.basketIconElement);
        this.targetElement.classList.add('basket--attached');
        this.targetElement.classList.remove('active');
        this.targetElement.addEventListener('click', function () { _this.eventBus.post("show-basket-ui" /* BasketEvent.ShowBasketUI */); });
        getTopMenuElement()
            .dispatchEvent(new CustomEvent("register-custom-top-menu-item" /* TopMenuEvent.RegisterCustomTopMenuItem */, { detail: this.targetElement }));
    };
    BasketIconComponent.prototype.getBasketWrapper = function () {
        var wrapper = document.createElement('div');
        wrapper.classList.add('top-menu__item', 'cart-item');
        return wrapper;
    };
    BasketIconComponent = __decorate([
        injectable(),
        __metadata("design:paramtypes", [BasketEventBus])
    ], BasketIconComponent);
    return BasketIconComponent;
}());
export { BasketIconComponent };
